/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Sort_Debt_DescInputs */

const vi_customer_sort_debt_desc = /** @type {(inputs: Customer_Sort_Debt_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nợ nhiều nhất`)
};

/**

* @param {Customer_Sort_Debt_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_sort_debt_desc = /** @type {((inputs?: Customer_Sort_Debt_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Sort_Debt_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_sort_debt_desc(inputs)
});